import { SET_DOCUMENTS, CLEAR_DOCUMENTS } from "../actions/documentActions";

const initialState = {
  documents: [],
  totalFilesize: 0,
  folders: {},
}

function documentReducer(state = initialState, action) {
  switch (action.type) {
  case SET_DOCUMENTS:
    return {
      ...state,
      documents: action.payload.documents,
      totalFilesize: action.payload.totalFilesize,
      folders: action.payload.folders,
    }
  case CLEAR_DOCUMENTS:
    return {
      ...state,
      documents: [],
      totalFilesize: 0,
      folders: {},
    }
  default:
    return state;
  }
}

export default documentReducer;